<button #spinnerButton *ngIf="!matIcon && !flatButton" mat-raised-button [ngClass]="{'spinner': processing, 'camelCase': camelCase}" [color]="color" (click)="emitButtonClick($event)" [disabled]="isDisabled()" [type]="type" [ngStyle]="{width: width}">
  <span *ngIf="!processing">{{buttonText}}</span>
  <mat-icon *ngIf="buttonText === 'Leave' && !processing">exit_to_app</mat-icon>
  <mat-spinner *ngIf="processing" [color]="color" diameter="20"></mat-spinner>
</button>


<button #spinnerButton *ngIf="matIcon && !flatButton" mat-raised-button [ngClass]="{'spinner': processing, 'camelCase': camelCase}" [color]="color" (click)="emitButtonClick($event)" [disabled]="isDisabled()" [type]="type" [ngStyle]="{width: width}">
  <div class="cmn-flex row align-center gutters-sm">
    <span *ngIf="!processing">{{buttonText}}</span>
    <mat-icon *ngIf="!processing" [fontSet]="fontSet">{{matIcon}}</mat-icon>
    <mat-spinner *ngIf="processing" [color]="color" diameter="20"></mat-spinner>
  </div>
</button>

<button #spinnerButton *ngIf="!matIcon && flatButton" mat-button [ngClass]="{'spinner': processing, 'camelCase': camelCase}" [color]="color" (click)="emitButtonClick($event)" [disabled]="isDisabled()" [type]="type" [ngStyle]="{width: width}">
  <span *ngIf="!processing">{{buttonText}}</span>
  <mat-spinner *ngIf="processing" [color]="color" diameter="20"></mat-spinner>
</button>

<button #spinnerButton *ngIf="matIcon && flatButton" mat-button [ngClass]="{'spinner': processing, 'camelCase': camelCase}" [color]="color" (click)="emitButtonClick($event)" [disabled]="isDisabled()" [type]="type" [ngStyle]="{width: width}">
  <div class="cmn-flex row align-center gutters-sm">
    <span *ngIf="!processing">{{buttonText}}</span>
    <mat-icon *ngIf="!processing" [color]="color" [fontSet]="fontSet">{{matIcon}}</mat-icon>
    <mat-spinner *ngIf="processing" [color]="color" diameter="20"></mat-spinner>
  </div>
</button>
